import { connect } from 'react-redux';

import ToSModal from './ToSModal';

const _mapStateToProps = (state) => ({
    showToS: state.frontend.showToS,
});

export default connect(_mapStateToProps)(ToSModal);
